import {
  getAddingPaymentCardAuthFormRoutes,
  getChoosingPlanRoutes,
} from "@/router/paymentPostAuthRoutes/pages";

import Route from "@/entities/Route";
import RouteNames from "@/entities/RouteNames";
import PaymentRoutesGuard from "@/router/guards/PaymentRoutesGuard.vue";

export const paymentPostAuthRoutes: Route[] = [
  {
    path: "payment",
    component: PaymentRoutesGuard, // This component is modified to always redirect to dashboard
    name: RouteNames.PAYMENT_ROUTES_GUARD,
    children: [
      ...getAddingPaymentCardAuthFormRoutes({}),
      ...getChoosingPlanRoutes({}),
    ],
  },
];
